import styled, { css, StyledComponent } from 'styled-components';

/** A component which displays children components in one line with no margin between them
 and removes rounded corners for components in the middle */
export const FieldInlineLayout = styled.div`
  & > :not(:first-child) {
    margin-left: -1px;
  }
  display: flex;
  align-items: stretch;
`;

export const supportFieldLineLayout = (subSelector: StyledComponent<any, any> | string = '') => css`
  ${FieldInlineLayout} > &:not(:last-child) ${subSelector}{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  ${FieldInlineLayout} > &:not(:first-child) ${subSelector}{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
`;
